'use client'
import React, { memo } from 'react';
import styles from "./styles.module.scss";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Montserrat } from "next/font/google";
import { useTranslations } from 'next-intl';
import { useAddFavoriteSingle } from '@/hooks/Query/useReport';


interface AddFavoriteProps {
  dataDetail: any;
  queryKey: (string | number | undefined | boolean |  null)[]
}

const montserrat = Montserrat({
  subsets: ["latin"],
});

const AddFavorite = ({ queryKey, dataDetail }: AddFavoriteProps) => {
  const  t  = useTranslations("messages");
  const queryClient = useQueryClient();

  const AddFavorite = useAddFavoriteSingle({
    queryKey: queryKey,
  });

  const handleFavorite = async () => {
    await AddFavorite.mutateAsync(Number(dataDetail?.id));
  };
  return (
    <Box
      className={`${styles.heart_mobile} absolute top-2 right-2`}
    >
      <Tooltip
        title={
          <span
            className={`${montserrat.className}`} // <-- Đảm bảo biến montserrat có sẵn ở đây
            translation-key={!dataDetail?.isFavorite ? 'common_favorite' : 'common_favorited'}
          >
            {!dataDetail?.isFavorite ? t('common_favorite') : t('common_favorited')}
          </span>
        }
        disableInteractive
        placement="bottom"
        slotProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -14], // Điều chỉnh vị trí của tooltip
                },
              },
            ],
          },
        }}
      >
        <IconButton
          className="!bg-white !p-1 !rounded h-8 cursor-pointer hover:bg-white shadow-none border-0 flex justify-center items-center"
          style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.10)' }}
          onClick={() => handleFavorite()}
        >
          {!dataDetail?.isFavorite ? (
            <FavoriteBorderIcon className="w-6 h-6 text-warning iconFavorite" />
          ) : (
            <FavoriteIcon className="w-6 h-6 text-warning iconFavorite" />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default memo(AddFavorite);